import React from 'react';

const ContactPage = () => {
    return (
        <div className="min-h-screen py-12">
            <div className="container mx-auto px-4">
                <h1 className="text-3xl font-bold mb-6">聯繫我們</h1>
                <p className="text-lg">這裡將展示聯繫表單（尚在開發中）...</p>
            </div>
        </div>
    );
};

export default ContactPage;